export default class SukuButton extends HTMLElement {
  static get observedAttributes() {
    return ['active', 'show', 'name', 'type', 'key']
  }

  constructor() {
    super()

    this.className = 'appearance-none text-base tracking-[-0.02em] cursor-pointer px-8 pt-2 pb-2 mx-1 mb-2 border border-black border-solid mobile:text-sm mobile:px-4 mobile:py-2'
    
    this.addEventListener('click', this.handleClick.bind(this))
  }

  connectedCallback() {
    this.active === this.getAttribute('active') === 'true' ? true : false
    this.show === this.getAttribute('show') === 'true' ? true : false
    this.name = this.getAttribute('name')
    this.key = this.getAttribute('key')
    this.type = this.getAttribute('type')
    this.dataValidation = this.getAttribute('data-validation')

    this.textContent = this.name
  }

  handleClick(evt) {
    this.dispatchEvent(new CustomEvent('filter', { bubbles: true, detail: { name: this.name, key: this.key, type: this.type } }))
  }

  toggle() {
    if (this.active) {
      this.classList.add('bg-black', 'text-white')
    } else {
      this.classList.remove('bg-black', 'text-white')
    }
  }

  showHide() {
    if (this.show) {
      this.classList.remove('hidden')
    } else {
      this.classList.add('hidden')
    }
  }

  attributeChangedCallback(name, current, value) {
    if (current === value) {
      return
    }

    switch (name) {
      case 'active' :
        this.active = value === 'true' ? true : false

        this.toggle()
        break
      case 'show' :
        this.show = value === 'true' ? true : false

        this.showHide()
        break
    }
  }
}

customElements.define('suku-button', SukuButton)
